
import {
  defineComponent, onMounted, ref,
} from 'vue';
import { Form } from 'vee-validate';
import { useRouter } from 'vue-router';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store/mainStore';
import { useRegistrationStore } from '@/modules/registration/store/registrationStore';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';
import AppButton from '@/components/UI/AppButton.vue';
import AppCheckbox from '@/components/UI/AppCheckbox.vue';

export default defineComponent({
  components: {
    Form,
    AppButton,
    AppCheckbox,
  },
  setup() {
    const router = useRouter();
    const mainStore = useMainStore();
    const registrationStore = useRegistrationStore();

    const coveredValue = ref(false);
    const protectedValue = ref(false);
    const authorizedValue = ref(false);

    // function nextStep() {
    //
    // }

    onMounted(() => {
      // if (!registrationStore.createUser?.email) {
      //   router.push('step-1');
      // }
      MonitoringService.sendPageMountedSpeed();
    });

    return {
      mainStore,
      // nextStep,
      coveredValue,
      protectedValue,
      authorizedValue,
    };
  },
});
